<template>
    <Header />
    <Slider v-model:search="search" @search="fetchCompanies" />
    <CompaniesTab v-model:search="search" @search="fetchCompanies"/>
    <Footer />
</template>

<script>
import Header from '../../components/Home/Header.vue';
import Slider from '../../components/Home/ٍSlider.vue';
import CompaniesTab from '@/components/Home/CompaniesTab.vue';
import Footer from '../../components/Home/Footer.vue';
import axios from 'axios';

export default {
    name: 'HomePage',
    components: {
        Header,
        Slider,
        CompaniesTab,
        Footer,
    },
    data() {
        return {
            search: null,
            page:1,
            companies:[]
        }
    },
    methods: {
        fetchCompanies() {
            axios.get(`/companies_search`, { params: { value: this.search, page: this.page,per_page:5,field:'name' } }).then(res=>{
                this.companies = res.data.data.companies
                const famousCompaniesSection = document.getElementById('famous-companies')
                famousCompaniesSection.scrollIntoView({ behavior: "smooth"})
            })
        }
    }
}
</script>
